export default {
  title: '巡检报告',

  section1Title: '一、任务信息',
  section2Title: '二、统计概览',
  section3Title: '三、巡检内容与结果',
  section4Title: '四、综合结论',

  deviceSn: '设备序列号',
  location: '巡检地点',
  executionTime: '执行时间',
  taskStatus: '任务状态',
  completed: '已完成',

  totalAnomalies: '检测到异常总数',
  abnormalHeatSourceCount: '异常热源数量',
  stackedObjectCount: '堆叠物数量',
  unit: '个',

  alarmDetails: '告警详情列表',
  totalAlarms: '共 {count} 条告警',

  subItem: '检查子项',
  standard: '标准/要求',
  result: '检查结果',
  remarks: '发现的问题/建议',

  serialNumber: '序号',
  problemDescription: '问题描述',
  urgency: '紧急程度',
  status: '状态',

  alarmType: '告警类型',
  positionXY: '位置 (X, Y)',
  createTime: '创建时间',
  alarmImage: '告警图片',

  labelRivet: '铆钉',
  labelCutterHandle: '刀具手柄',
  labelScrewdriver: '螺丝刀',
  labelBackpack: '背包',
  labelBottle: '瓶子',

  qualified: '合格',
  unqualified: '不合格',
  attention: '注意',

  urgencyEmergency: '紧急',
  urgencyHigh: '高',
  urgencyMedium: '中',
  urgencyLow: '低',

  inspectionCategory: '检测项',
  inspectionCheck: '{name}检测',
  standardNotFound: '未发现{name}',
  remarksDetected: '检测到{name}{count}处，建议及时处理。',
  remarksNotFound: '未发现{name}，符合要求。',

  rectificationDetected: '检测到{name}{count}处，建议尽快处理并复检',
  responsibleSafety: '安全管理部门',
  deadline3Days: '3个工作日内',
  statusPending: '待处理',

  defaultLocation: '上海市浦东新区祝桥镇上飞路919号',
  reportSummaryIntro: '机器狗{sn}，在{location}，于{createTime}执行了巡检任务，任务已完成',
  inspectionSummary: '巡检摘要:',
  noAnomaly: '无异常',
  foundAnomalies: '发现了{content}',
  anomalyRecords: '异常记录:',
  conclusionAndSuggestion: '巡检结论与建议:',
  suggestTimelyHandle: '建议及时处理并复检',
  foundPrefix: '发现{content}',
  foundWithSuggestion: '发现{content},{suggestion}',
  noAnomalyFound: '未发现异常',
  listSeparator: '、',

  conclusionPrefix: '本次巡检',
  conclusionNonCompliant: '发现{count}项不合格项，需立即整改；',
  conclusionAttention: '发现{count}个风险点，需重点关注。',
  conclusionFollowUp: '请按整改建议及时落实整改措施，并跟踪整改进度。',
  conclusionWithAlarms: '本次巡检共产生{count}条告警记录，请结合巡检明细与告警详情及时核查处理。',
  conclusionAllGood: '本次巡检整体情况良好，未发现异常情况，各项检查指标均符合要求。',

  missingTaskId: '缺少任务ID，无法获取巡检报告数据',
  requestFailed: '请求失败',
}
